import { SuperDate } from '@razlet/utils';
import Dictionary from '../dictionary';
import { unixTimeToStr } from '~/utils/date';

export default class RoutePoint {
  data = null;
  side = 'departure';

  date = null;
  estimatedDate = null;

  waitTime = null;

  #dictionary = new Dictionary({});

  constructor (data, waitTime = 0, side = 'departure', dictionary = {}) {
    this.data = data;
    this.side = side;
    this.waitTime = waitTime;

    this.#dictionary = new Dictionary(dictionary);

    this.date = new SuperDate(data.time);
    if (data.estimatedTime) this.estimatedDate = new SuperDate(data.estimatedTime);
  }

  get isDeparture () {
    return this.side === 'departure';
  }

  get isArrival () {
    return this.side === 'arrival';
  }

  get isStopover () {
    return this.side === 'stopover';
  }

  get isTransfer () {
    return this.side === 'transfer';
  }

  get airport () {
    return this.data.airport;
  }

  get estimatedAirport () {
    return this.data.estimatedAirport;
  }

  get isPointChanged () {
    return this.estimatedAirport && this.airport !== this.estimatedAirport;
  }

  get airportName () {
    return this.#dictionary.getBy('airport', this.airport, 'name');
  }

  get estimatedAirportName () {
    return this.#dictionary.getBy('airport', this.estimatedAirport, 'name');
  }

  get plannedCode () {
    return this.airport;
  }

  get actualAirport () {
    if (this.isPointChanged) return this.estimatedAirport;
    return this.airport;
  }

  get actualAirportName () {
    if (this.isPointChanged) return this.estimatedAirportName;
    return this.airportName;
  }

  get code () {
    return this.actualAirport;
  }

  get groupCode () {
    return this.city;
  }

  get groupName () {
    return this.cityName;
  }

  get shortName () {
    return this.code;
  }

  get city () {
    return this.data.city;
  }

  get cityName () {
    return this.#dictionary.getBy('city', this.city, 'name');
  }

  get plannedAdditionalName () {
    return this.airportName;
  }

  get additionalName () {
    return this.actualAirportName;
  }

  get name () {
    return this.cityName;
  }

  get date () {
    return this.date;
  }

  get estimatedDate () {
    return this.estimatedDate;
  }

  get waitTimePretty () {
    return unixTimeToStr(this.waitTime, 'letters');
  }

  get fullName () {
    return `${this.city}(${this.actualAirport}) - ${this.date.shortDateWithTime}`;
  }
};
